import React from 'react';
import { MessageSquareIcon, HeartHandshakeIcon, FileTextIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { SectionHeading } from '../SectionHeading';
const points = [{
  icon: MessageSquareIcon,
  title: {
    en: 'Clear communication',
    es: 'Comunicación clara'
  },
  body: {
    en: 'Estimates, schedules and change orders explained in the language you are most comfortable in — nothing signed that you do not fully understand.',
    es: 'Presupuestos, horarios y cambios explicados en el idioma en que te sientas más cómodo — nada se firma sin que lo entiendas por completo.'
  }
}, {
  icon: HeartHandshakeIcon,
  title: {
    en: 'Cultural understanding',
    es: 'Entendimiento cultural'
  },
  body: {
    en: 'We are a Latino family business serving a bilingual city. We understand how families use their homes and we work around your household.',
    es: 'Somos un negocio familiar latino en una ciudad bilingüe. Entendemos cómo las familias usan su casa y trabajamos alrededor de tu hogar.'
  }
}, {
  icon: FileTextIcon,
  title: {
    en: 'Paperwork in both languages',
    es: 'Documentos en ambos idiomas'
  },
  body: {
    en: 'Written quotes, warranty terms and invoices available in English or Spanish, so your records are as clear as our conversations.',
    es: 'Presupuestos escritos, garantías y facturas disponibles en inglés o español, para que tus documentos sean tan claros como nuestras conversaciones.'
  }
}];
export function BilingualSection() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white" aria-labelledby="bilingual-heading" data-id="element-127" data-mp="5iamd3bjr8j9">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24" data-id="element-128" data-mp="5k3w4rhgi8vh">
        <div className="rounded-2xl bg-gold-50 px-6 py-12 sm:px-12" data-id="element-129" data-mp="9hrq9sbbrxmb">
          <SectionHeading id="bilingual-heading" align="center" eyebrow="English & Español" title={t({
          en: 'Ofrecemos servicios en inglés y español',
          es: 'Ofrecemos servicios en inglés y español'
        })} description={t({
          en: 'Hablamos tu idioma. Every call, estimate and job site is handled bilingually — because a remodel goes wrong when people stop understanding each other.',
          es: 'Hablamos tu idioma. Cada llamada, presupuesto y obra se maneja en los dos idiomas — porque una remodelación falla cuando la gente deja de entenderse.'
        })} data-id="element-130" data-mp="2q7qhublpnlf8" />
          <ul className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-131" data-mp="d0qx6iv8zo19">
            {points.map(point => <li key={point.title.en} className="border-t border-navy/15 pt-6" data-id="element-132" data-mp="81no8nc5cxo0">
                <point.icon className="h-7 w-7 text-navy" aria-hidden="true" data-id="element-133" data-mp="33448sh45vya" />
                <h3 className="mt-4 font-display text-xl text-navy" data-id="element-134" data-mp="3574e5bzd5gq">{t(point.title)}</h3>
                <p className="mt-2 leading-relaxed text-ink/75" data-id="element-135" data-mp="22ff5o90pwlu0">{t(point.body)}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}